import apiClient from '../helpers/apiClient';

import { authHeader } from '../helpers/authHeader';

export const customerService = {
  saveGeneralInformation,
  saveCustomerAddress,
  getMasterData,
  saveCustomerLocation,
  saveCustomerOtherInfo,
  getSingleCustomer,
  updateCustomer,
  getNotifications,
  getAllCustomers,
  submitCustomerImage,
  saveContactPerson,
  customerDetailsHistory,
  customerDetailBills,
  getCustomerListNoCache,
  getCustomerListSearch,
  changeCustomerStatus,
  getRatingList,
  getRatingDetails,
  submitReplyToRating,
  getRewardHistory,
  getCustomerVouchers,
  getCustomerTransactions,
  customerCreditScore,
  customerDetailsGift,
  getCustomerByDate,
  getCustomerBySearch,
  uploadCustomerProfile,
};

async function submitCustomerImage(formdata) {
  return apiClient.post('/submit-customer-image', formdata, authHeader());
}

async function getAllCustomers() {
  var userPref = { sql_ref_no: 6, option: 2, c_code: 1001 };
  return apiClient.post('/all-customers', userPref, authHeader());
}

async function getRatingList() {
  return apiClient.get('/subscriptions/rating-list', authHeader());
}

async function getRatingDetails(id, min, max) {
  return apiClient.get(`/subscriptions/rating-details/${id}/${min}/${max}`, authHeader());
}

async function submitReplyToRating(data) {
  return apiClient.post(`/subscriptions/reply-to-rating`, data, authHeader());
}

async function getCustomerListNoCache(start = 0, end = 50) {
  return apiClient.get(`/customer-list-no-cache?start=${start}&end=${end}`, authHeader());
}

async function getCustomerByDate(body) {
  return apiClient.put(`/customer-list-by-date`, body, authHeader());
}

async function uploadCustomerProfile(body) {
  return apiClient.post(`/upload-customer-img`, body, authHeader());
}

async function getCustomerBySearch(searchText) {
  return apiClient.get(`/customer-by-search?search=${searchText}`, authHeader());
}

async function getCustomerListSearch(search) {
  return apiClient.get(`/customer-list-search?search=${search}`, authHeader());
}

async function getRewardHistory(id) {
  return apiClient.get(`/get-reward-history/${id}`, authHeader());
}

async function getCustomerVouchers(id) {
  return apiClient.get(`/get-customer-vouchers/${id}`, authHeader());
}

async function getCustomerTransactions(id) {
  return apiClient.get(`/get-customer-transaction/${id}`, authHeader());
}

async function saveGeneralInformation(body) {
  return apiClient.post(`/save-general-info`, body, authHeader());
}

async function saveContactPerson(body) {
  return apiClient.post('/save-contact-person', body, authHeader());
}

async function changeCustomerStatus(bodyData) {
  return apiClient.put(`/change-customer-status`, bodyData, authHeader());
}

async function updateCustomer(body) {
  return apiClient.put(`/update-customer`, body, authHeader());
}

async function saveCustomerAddress(body) {
  return apiClient.put('/save-address', body, authHeader());
}

async function saveCustomerLocation(body) {
  return apiClient.put('/save-location', body, authHeader());
}

async function saveCustomerOtherInfo(body) {
  return apiClient.put('/save-other-info', body, authHeader());
}

async function getMasterData() {
  return apiClient.get('/get-master-data', authHeader());
}

async function getSingleCustomer(customer_id) {
  return apiClient.get(`/get-single-customer/${customer_id}`, authHeader());
}

function getNotifications(customer_id) {
  return apiClient.get(`/customer-notification/${customer_id}`, authHeader());
}

function customerDetailsHistory(customer_id) {
  return apiClient.get(`/customer-history/${customer_id}`, authHeader());
}

function customerDetailsGift(customer_id) {
  return apiClient.get(`/customer-gift/${customer_id}`, authHeader());
}

function customerCreditScore(customer_id) {
  return apiClient.get(`/customer-credit-score-record/${customer_id}`, authHeader());
}

function customerDetailBills(customer_id) {
  return apiClient.get(`/customer-bills/${customer_id}`, authHeader());
}
